import AtiraLinkMainIcon from './atiralink-main-icon.png';
import AtiraLinkMainLogo from './atiralink-main-logo.png';
import AtiraLinkSubIcon from './atiralink-sub-icon.png';
import AtiraLinkSubLogo from './atiralink-sub-logo.png';
import BlogPlaceholder from './blog-placeholder-image.png';
import GoogleIcon from './google.svg';
import InstagramEditAR from './instagram-edit-ar.webp';
import InstagramEditEN from './instagram-edit-en.webp';
import InstagramEditTR from './instagram-edit-tr.webp';
import PreviewDesktop from './preview-desktop.png';
import PreviewIpad from './preview-ipad.png';
import PreviewMobile from './preview-mobile.png';
import RegisterBackground from './register-bg.webp';
import SaudiFlag from './saudi-flag.svg';
import Sparkles from './sparkles.png';
import TikTokBioAR from './tiktok-bio-ar.webp';
import TikTokBioEN from './tiktok-bio-en.webp';
import TikTokBioTR from './tiktok-bio-tr.webp';
import TikTokEditAR from './tiktok-edit-ar.webp';
import TikTokEditEN from './tiktok-edit-en.webp';
import TikTokEditTR from './tiktok-edit-tr.webp';
import TurkishFlag from './turkish-flag.svg';
import USAFlag from './usa-flag.svg';

export const Images = {
  AtiraLinkMainLogo,
  AtiraLinkSubLogo,
  AtiraLinkMainIcon,
  AtiraLinkSubIcon,
  Sparkles,
  PreviewMobile,
  PreviewIpad,
  PreviewDesktop,
  RegisterBackground,
  BlogPlaceholder,
  InstagramEditAR,
  InstagramEditEN,
  InstagramEditTR,
  TikTokEditAR,
  TikTokEditEN,
  TikTokEditTR,
  TikTokBioAR,
  TikTokBioEN,
  TikTokBioTR,
  GoogleIcon,
  SaudiFlag,
  TurkishFlag,
  USAFlag,
};
